exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.my-padding {\n  padding: 1rem 1rem;\n  margin: auto;\n}\n/*# sourceMappingURL=src/components/tree-wiki.css.map */", "", {"version":3,"sources":["D:/ts2/src/components/src/components/tree-wiki.vue","D:/ts2/src/components/tree-wiki.vue"],"names":[],"mappings":";AAmHA;EACE,mBAAA;EACA,aAAA;CClHD;AACD,wDAAwD","file":"tree-wiki.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.my-padding\n  padding 1rem 1rem\n  margin auto\n",".my-padding {\n  padding: 1rem 1rem;\n  margin: auto;\n}\n/*# sourceMappingURL=src/components/tree-wiki.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tree-wiki.vue
// module id = QYmh
// module chunks = 0 1 2 3